import { CBadge, CNavLink, CSidebarNav } from '@coreui/react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import 'simplebar-react/dist/simplebar.min.css';
import SimpleBar from 'simplebar-react';

import { H4 } from '../../shared/typography';

export const AppSidebarNav = ({ items }: any) => {
	const navLink = (name: any, icon: any, badge: any, indent = false) => {
		return (
			<>
				{icon
					? icon
					: indent && (
							<span className='nav-icon'>
								<span className='nav-icon-bullet'></span>
							</span>
						)}
				{name && name}
				{badge && (
					<CBadge className='ms-auto' color={badge.color}>
						{badge.text}
					</CBadge>
				)}
			</>
		);
	};

	const navItem = (item: any, index: any, indent = false) => {
		const { badge, component, icon, name, ...rest } = item;
		const Component = component;

		return (
			<Component as='div' key={index}>
				{rest.to || rest.href ? (
					<H4>
						<CNavLink {...(rest.to && { as: NavLink })} {...rest}>
							{navLink(name, icon, badge, indent)}
						</CNavLink>
					</H4>
				) : (
					navLink(name, icon, badge, indent)
				)}
			</Component>
		);
	};

	const navGroup = (item: any, index: any) => {
		const { component, icon, name, ...rest } = item;
		const Component = component;
		return (
			// @ts-ignore
			<Component
				as='div'
				compact
				key={index}
				// @ts-ignore
				toggler={navLink(name, icon)}
				{...rest}
			>
				{item.items?.map((item: any, index: any) => (item.items ? navGroup(item, index) : navItem(item, index, true)))}
			</Component>
		);
	};

	return <CSidebarNav as={SimpleBar}>{items && items.map((item: any, index: any) => (item.items ? navGroup(item, index) : navItem(item, index)))}</CSidebarNav>;
};

AppSidebarNav.propTypes = {
	items: PropTypes.arrayOf(PropTypes.any).isRequired,
};
